// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/$.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/$.tsx");
  import.meta.hot.lastModified = "1773385375631.6575";
}
// REMIX HMR END

import { json, redirect } from "@remix-run/cloudflare";
import { useLoaderData } from "@remix-run/react";
import getToken from "~/drupal/auth.server";
import { getClient } from "~/drupal/client.server";
import { metaTags } from "drupal-remix";
import { Fragment } from "react";
import Heading from "~/components/Heading";
import Footer from "~/components/navigation/Footer";
import Navbar from "~/components/navigation/Navbar";
import NodeArticleComponent from "~/components/node/NodeArticle";
import NodePageComponent from "~/components/node/NodePage";
import QuickAccessModal from "~/components/QuickAccessModal";
import { InfoFragment } from "~/drupal/fragments/info.server";
import { FooterMenuFragment, MainMenuFragment } from "~/drupal/fragments/menus.server";
import { RouteInternalFragment } from "~/drupal/fragments/nodes.server";
import { calculatePath } from "~/utils/routes";
const NodeTypeComponents = new Map();
NodeTypeComponents.set("NodePage", NodePageComponent);
NodeTypeComponents.set("NodeArticle", NodeArticleComponent);
export const meta = ({
  data
}) => {
  return metaTags({
    tags: data.node.metatag,
    metaTagOverrides: {
      MetaTagLink: {
        canonical: [{
          pattern: "live-octahedroid.pantheonsite.io",
          replacement: "octahedroid.com"
        }]
      },
      MetaTagProperty: {
        "og:url": [{
          pattern: "live-octahedroid.pantheonsite.io",
          replacement: "octahedroid.com"
        }]
      }
    }
  });
};
export const loader = async ({
  params,
  context,
  request
}) => {
  const path = calculatePath({
    path: params["*"],
    url: request.url
  });
  const token = await getToken(context);
  const drupalClient = getClient(token, context);
  const {
    route,
    menu,
    info
  } = await drupalClient.query({
    route: {
      __args: {
        path: path
      },
      __typename: true,
      on_RouteInternal: {
        ...RouteInternalFragment
      }
    },
    menu: {
      __args: {
        name: "MAIN"
      },
      ...MainMenuFragment
    },
    info: {
      ...InfoFragment
    }
  });
  const {
    menu: footer
  } = await drupalClient.query({
    menu: {
      __args: {
        name: "FOOTER"
      },
      ...FooterMenuFragment
    }
  });
  if (!route || route.__typename !== "RouteInternal" || !route.entity) {
    return redirect("/404");
  }
  return json({
    node: route.entity,
    menu,
    footer,
    info,
    environment: context.ENVIRONMENT
  }, {
    status: 200
  });
};
export default function Index() {
  _s();
  const {
    node,
    menu,
    footer,
    info,
    environment
  } = useLoaderData();
  const Component = NodeTypeComponents.get(node?.__typename);
  if (!node || !Component) {
    return <Heading tag="h1">Not Found</Heading>;
  }
  return <Fragment>
      <Navbar navigation={menu?.items} information={info} />
      <Component node={node} environment={environment} />
      <QuickAccessModal />
      <Footer navigation={footer?.items} />
    </Fragment>;
}
_s(Index, "ZiEFJwtHvpl9+1+Eyj91Bm6/Z5g=", false, function () {
  return [useLoaderData];
});
_c = Index;
var _c;
$RefreshReg$(_c, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;